import { api } from './client';
import type { RequestItem, RequestType } from './types';

export async function getRequestTypes(): Promise<RequestType[]> {
    const { data } = await api.get<{ content?: RequestType[] }>('/request/type/list');
    return data.content ?? [];
}

/** Tipi visibili anche se nascosti (rotta admin): per la pagina di gestione. */
export async function getAdminRequestTypes(): Promise<RequestType[]> {
    const { data } = await api.get<{ content?: RequestType[] }>('/request/type/admin');
    return data.content ?? [];
}

export async function addRequestType(name: string) {
    const { data } = await api.post('/request/type/add', { name });
    return data;
}

export async function deleteRequestType(id: number) {
    const { data } = await api.post('/request/type/delete', { id });
    return data;
}

export interface NewRequestPayload {
    event: number;
    title: string;
    author?: string;
    dedication?: string;
    tono?: string;
    type: number;
}

export async function addRequest(payload: NewRequestPayload) {
    const { data } = await api.post('/request/add', payload);
    return data;
}

export async function getEventRequests(eventId: number, signal?: AbortSignal): Promise<RequestItem[]> {
    const { data } = await api.get<{ content?: RequestItem[] }>('/request/list', {
        params: { event_id: eventId },
        signal,
    });
    return data.content ?? [];
}

export async function updateRequest(id: number) {
    const { data } = await api.post('/request/update', { id });
    return data;
}
